import { redirectToLogin, redirectToZlogin } from '../components/auth/redirect';

const getNetworkStatus = (networkError) => networkError?.statusCode || networkError?.status || networkError?.response?.status;

const getErrorCode = (error) => error?.extensions?.errorcode || error?.extensions?.code || error?.errorcode || error?.code;

const getNetworkErrorCodes = (networkError) => {
    const result = networkError?.result || networkError?.response?.data;
    const errors = Array.isArray(result?.errors) ? result.errors : [];

    return [getErrorCode(result), ...errors.map(getErrorCode)].filter(Boolean);
};

export const errorHandling = (errorCode) => {
    switch (errorCode) {
        case 'B1009':
        case 'ONEQREW_REQUIRED':
            redirectToZlogin();
            break;
        default:
            console.log(`Untreated Errorcode: ${errorCode}`);
    }
};

export const networkErrorHandling = (networkError) => {
    const status = getNetworkStatus(networkError);
    const errorCodes = getNetworkErrorCodes(networkError);

    if (status === 401 || (status === 403 && errorCodes.includes('ONEQREW_REQUIRED'))) {
        redirectToLogin();
        return true;
    }

    return false;
};
